export const INSPECTION_TYPES = {
  ROUGH: {display: 'Rough', value: 'Rough', showOrder: 1, def: false},
  FINAL: {display: 'Final', value: 'Final', showOrder: 0, def: false},
};

